<section class="pdfc-card">
  <h1 class="title">
    Product Data Filename Convention
  </h1>

  @if (loaded) {
    @if (hasConvention && latest !== null) {
      <div class="pdfc-details">
        <div class="detail-row">
          <span class="detail-label">Filename identifier</span>
          <span class="detail-value">{{ identifierLabel(latest.filename.identifier) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Extensions</span>
          <span class="detail-value bubbles">
            @for (ext of latest.filename.extensions; track ext) {
              <span class="bubble">{{ extensionLabel(ext) }}</span>
            }
          </span>
        </div>
        @if (sampleFilenames.length > 0) {
          <div class="preview">
            <span class="preview-label">Sample</span>
            <div class="preview-list">
              @for (sample of sampleFilenames; track sample) {
                <code class="preview-item">{{ sample }}</code>
              }
            </div>
          </div>
        }
        <div class="pdfc-actions">
          <a
            mat-icon-button
            color="primary"
            class="history-button"
            aria-label="View change history"
            matTooltip="View change history"
            [routerLink]="['/organizations', organizationId, 'product-data-filename-conventions']"
          >
            <mat-icon>history</mat-icon>
          </a>
          <button
            mat-icon-button
            color="buttonSuccess"
            class="pdfc-edit-button"
            aria-label="Update product data filename convention"
            matTooltip="Update"
            (click)="openUpdateDialog()"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    } @else {
      <div class="pdfc-details pdfc-example">
        <div class="detail-row">
          <span class="detail-label">Filename identifier</span>
          <span class="detail-value"></span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Extensions</span>
          <span class="detail-value"></span>
        </div>
        <div class="pdfc-actions">
          <button
            mat-stroked-button
            color="buttonSuccess"
            class="pdfc-create-button"
            (click)="openCreateDialog()"
          >
            Create
          </button>
        </div>
      </div>
    }
  }
</section>
